import React from 'react';
import QuickviewImageLoadingComponent from './QuickviewImageLoadingComponent';

const Skeleton = ({ className }) => (
  <div className={`${className} loading`} />
);

const MobileView = () => (
  <>
    <div className="product-name-and-description-container">
      <Skeleton className="product-name-and-description-loading" />
    </div>
    <section className="quickview-add-to-bag-container quickview-content-scroll">
      <QuickviewImageLoadingComponent variant="mobileImage" />
      <div className="quickview-add-to-bag-skeleton-wrapper mobile" data-testid="quickview-add-to-bag-form-wrapper">
        <Skeleton className="product-name-and-description-loading" />
        <QuickviewImageLoadingComponent variant="mobileThumbnails" />
        <Skeleton className="product-name-and-description-loading mobile" />
        <Skeleton className="quickview-atb skeleton mobile" />
      </div>
    </section>
  </>
);

const DesktopView = () => (
  <>
    <div className="quickview-image-container quickview-image-container-loading">
      <QuickviewImageLoadingComponent variant="desktop" />
    </div>
    <section className="quickview-add-to-bag-container quickview-content-scroll">
      <div className="quickview-add-to-bag-skeleton-wrapper" data-testid="quickview-add-to-bag-form-wrapper">
        <Skeleton className="quickview-atb skeleton" />
        <Skeleton className="quickview-atb skeleton" />
        <Skeleton className="quickview-atb skeleton" />
      </div>
      <div className="quickview-atb-action-loading">
        <Skeleton className="quickview-action-section skeleton" />
        <Skeleton className="quickview-action-section skeleton" />
      </div>
    </section>
  </>
);

export default function QuickviewLoading({ isMobile }) {
  return (
    <div className="quickview-modal-wrapper">
      {isMobile ? <MobileView /> : <DesktopView />}
    </div>
  );
}
